import { render, staticRenderFns } from "./creditCheck.vue?vue&type=template&id=ec1c4342&scoped=true&"
import script from "./creditCheck.vue?vue&type=script&lang=js&"
export * from "./creditCheck.vue?vue&type=script&lang=js&"
import style0 from "./creditCheck.vue?vue&type=style&index=0&id=ec1c4342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1c4342",
  null
  
)

export default component.exports